<template>
  <div id="auth">
    <div v-if="loading" id="preloader">
      <div class="lds-circle"><div></div></div>
    </div>
    <div v-else>
      <!-- Page Content -->
      <div class="page-content">
        <!-- Banner -->
        <div class="banner-wrapper shape-1">
          <div class="container inner-wrapper">
            <img src="assets/images/logo/logo-sm.png" class="mx-auto" />
            <h3 class="dz-title mt-2">Hola, bienvenido a Reddy</h3>
            <p class="mb-0">Digita tu correo electrónico para empezar</p>
          </div>
        </div>
        <div v-if="loading_email" class="container">
          <div class="text-center mt-5">
            <small class="text-muted">Cargando...</small><br />
            <div class="lds-circle"><div></div></div>
          </div>
        </div>
        <div v-else>
          <!-- Banner End -->
          <transition appear name="slide-fade">
            <div v-if="!success" class="container">
              <div class="account-area">
                <form class="" v-on:submit.prevent="set_email_registro">
                  <div class="input-group">
                    <input
                      v-model="email"
                      type="text"
                      placeholder="Correo electrónico"
                      class="form-control"
                    />
                  </div>

                  <div class="input-group">
                    <button
                      type="submit"
                      class="btn mt-2 btn-primary w-100 btn-rounded"
                    >
                      Siguiente <i class="fa fa-chevron-right"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </transition>
          <transition appear name="slide-fade">
            <div v-if="success" class="container">
              <div class="account-area text-center">
                <div class="alert alert-primary p-3" style="font-size: 1.2em">
                  <i class="bx bxs-check-circle bx-sm"></i> <br />
                  Hemos enviado a la dirección de correo electrónico registrada
                  en tu membresía de Reddy las indicaciones para crear tu
                  cuenta. Revisa la bandeja de entrada y sigue las
                  instrucciones.
                </div>
              </div>
            </div>
          </transition>
          <transition appear name="slide-fade">
            <router-link
              to="/auth"
              class="btn btn-primary light btn-rounded text-primary d-block"
              >Iniciar sesión</router-link
            >
          </transition>
        </div>
      </div>
      <!-- Page Content End -->
      <!-- Footer -->
      <footer class="footer fixed">
        <!--   <div class="container">
          <router-link
            to="/auth"
            class="btn btn-primary light btn-rounded text-primary d-block"
            >Iniciar sesión</router-link
          >
        </div> -->
      </footer>
      <!-- Footer End -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Registro",
  metaInfo: {
    title: "Crea tu cuenta - Reddy App",
  },
  data() {
    return {
      loading: true,
      loading_email: false,
      email: null,
      success: false,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session != undefined) {
      this.$router.push("/");
      return false;
    }
  },
  methods: {
    set_email_registro: function () {
      if (this.email == null || this.email == "") {
        this.$notify({
          type: "error",
          group: "foo",
          title: "<i class='fa fa-exclamation-circle'></i> Ups!",
          text: "Digita tu correo electrónico registrado en Reddy.",
        });
        return false;
      }
      this.loading_email = true;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
      };
      let params = {
        email: this.email,
      };
      const vm = this;
      axios
        .post(this.$base_url + "auth/email_registro", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
            vm.loading_email = false;
            return false;
          } else {
            vm.success = true;
            vm.loading_email = false;
          }
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
  },
  mounted: function () {
    this.loading = false;
  },
};
</script>